import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionMigrationCloud.css';

const IntroSectionMigrationCloud3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Migration Cloud
  const migrationStats = [
    {
      value: '90%',
      label: 'Réduction des coûts',
      translationKey: 'migrationCloud.stats.cost',
      labelTranslationKey: 'migrationCloud.stats.costLabel'
    },
    {
      value: '3x',
      label: 'Performance améliorée',
      translationKey: 'migrationCloud.stats.performance',
      labelTranslationKey: 'migrationCloud.stats.performanceLabel'
    },
    {
      value: '100%',
      label: 'Disponibilité garantie',
      translationKey: 'migrationCloud.stats.availability',
      labelTranslationKey: 'migrationCloud.stats.availabilityLabel'
    },
    {
      value: '∞',
      label: 'Évolutivité assurée',
      translationKey: 'migrationCloud.stats.scalability',
      labelTranslationKey: 'migrationCloud.stats.scalabilityLabel'
    }
  ];

  return (
    <div className="intro-section-home">
      <div className="container-max-width intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('migrationCloud.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <div className="container-max-width">
          <FeaturedSectionStats
          title={t('migrationCloud.stats.title', 'Passez en production sur Azure en moins de 4 semaines.')}
          subtitle={t('migrationCloud.stats.subtitle', 'Nous vous assurons une migration maîtrisée de bout en bout, une sécurité intégrée by design, un budget optimisé en continu, une bascule sans impact sur votre activité et l\'autonomie garantie de vos équipes à la livraison.')}
          titleTranslationKey="migrationCloud.stats.title"
          subtitleTranslationKey="migrationCloud.stats.subtitle"
          stats={migrationStats}
          showChart={false}
        />
      </div>
    </div>
  );
};

export default IntroSectionMigrationCloud3;